import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedList } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { FormattedMessagePropType } from '../../../../../../prop-types/intl';
import collapsibleStyle from '../collapsible/collapsible.module.less';
import { useManageSubscriptionDrawerContext } from '../../../context/manage-subscription-drawer-context';
import { useGetSubscriptionCurrencyCode } from '../../../hooks/use-get-subscription-currency-code';
import { FormattedCurrency } from '../../../../../../components/formatted-currency';
import { upsellModalContent } from '../../../../../../components/upsell-modal/messages';

import { getLineItemPlanSummaryForDisplay } from '../helpers';
import { messages } from './messages';

const FeatureList = ({ formattedMessages, truncateAfter = 2 }) => {
  const length = formattedMessages.length;
  const remaining = length - truncateAfter;
  const formattedMessagesToShow = formattedMessages.slice(0, truncateAfter);

  if (remaining > 0) {
    formattedMessagesToShow.push(<FormattedMessage key='remaining' {...messages.moreRemaining} values={{ remaining }} />);
  }

  return <FormattedList type='unit' value={formattedMessagesToShow} />;
};

FeatureList.propTypes = {
  formattedMessages: PropTypes.arrayOf(FormattedMessagePropType).isRequired,
  truncateAfter: PropTypes.number,
};

export const CollapsibleAddOnsHeader = ({ shouldHidePrice = false }) => {
  const { visibleLineItems, addOnsToAdd, addOnsToRemove, isMigratingToNewestPlans } = useManageSubscriptionDrawerContext();

  const subscriptionCurrencyCode = useGetSubscriptionCurrencyCode();
  const filteredLineItems = getLineItemPlanSummaryForDisplay(
    visibleLineItems,
    addOnsToAdd,
    addOnsToRemove,
    isMigratingToNewestPlans,
  ).filter((lineItem) => !lineItem.isDeactivated);
  const featureCosts = filteredLineItems.reduce((sum, current) => {
    return sum + current.price.value;
  }, 0);
  const formattedMessages = filteredLineItems.map((lineItem) => (
    <FormattedMessage key={lineItem.code} {...upsellModalContent[lineItem.code].name} />
  ));

  return (
    <div className={collapsibleStyle['header-text-wrapper']}>
      <Text textType={TextType.H3} value={<FormattedMessage {...messages.addOnsTitle} />} />
      <div className={collapsibleStyle['header-price']}>
        <Text
          className={collapsibleStyle['header-selected-state-label']}
          textType={TextType.Caption}
          value={<FeatureList formattedMessages={formattedMessages} />}
        />
        {!shouldHidePrice && (
          <Text textType={TextType.H3} value={<FormattedCurrency currencyCode={subscriptionCurrencyCode} value={featureCosts} />} />
        )}
      </div>
    </div>
  );
};
